<!--  -->
<template>
  <div class="app-content">
    <div class="outer-container">
      <img src="@/assets/bg-top.png" alt="image" class="top-image">
      <div class="goods-container">
        <div class="container-name">代办服务</div>
        <div class="item-list-container">
          <div v-for="(item,index) in agenciesList" :key="index">
            <div class="perItem-last"> 
              <div style="display: flex; justify-content: space-between;">
                <div class="item-left">
                  <van-checkbox icon-size="16px" checked-color="#007aaa" @change="handleSelectedChange(index)"  v-model="item.checked"
                    class="regular-checkbox"></van-checkbox>
                </div>
                <div class="item-middle">
                  <img :src="item.photo" class="ticket-picture">
                </div>
                <div class="item-right">
                  <div class="perItem-name">{{ item.name }}</div>
                  <div class="perItem-description">{{ item.description }}</div>
                  <div class="item-wrap">
                    <div class="perItem-price">¥ {{ item.price }}</div>
                    <div class="perItem-count">
                      <van-stepper @change="handleChange(index)" v-model="item.count" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-container">
        <div class="money-detail-wrap" style="display: flex;">
          <div class="money-wrap">
            <span class="symbol">¥</span>
            <span class="money">{{ totalMoney }}</span>
          </div>
          <div class="detail-wrap" @click="showPriceDetail = !showPriceDetail">
            <span class="detail-text">明细</span>
            <img src="../assets/mingxijiantou.png" alt="arrow-down" class="order-price-fold">
          </div>
        </div>
        <div class="submit-order" @click="onNextStep">下一步</div>
      </div>
      <div class="price-detail-mask" style="display: none;"></div>
      <van-popup class="order-price-container" v-model="showPriceDetail" position="bottom" round>
        <img src="../assets/close.png" alt="close" @click="showPriceDetail = false">
        <div class="detail-title">价格明细</div>
        <div class="scroll-wrapper" >
          <div class="price-type">
            <div class="price-type-name">法会活动</div>
            <div class="price-type-money">￥{{ meetingMoney }}</div>
          </div>
          <div class="cell">
            <div class="title">功德经资</div>
            <div class="money">¥{{ meetingMoney }}<span> x {{Array.isArray(memorialsItems) && memorialsItems.length >= 1   ? memorialsItems.length : 1}}</span></div>
          </div>
          <div v-if="selectedItems.length != 0" class="price-type" style="margin-top: 15px;">
            <div class="price-type-name">待办服务</div>
            <div class="price-type-money">￥{{  totalMoney - meetingMoney}}</div>
          </div>
          <div  v-for="(selectedItem, selectedIndex) in selectedItems" :key="selectedIndex"  class="checkList-container">
            <div>
              <div class="cell">
                <div class="title">{{selectedItem.name}}</div>
                <div class="money">¥{{selectedItem.price}}x{{ selectedItem.count }}</div>
              </div>
            </div>
          </div>
        </div>
      </van-popup>
      <div id="moveDiv" class="btn-home" @click="goHome">
        <img src="../assets/shouye.png" class="img-home">
        <div class="text-home">首页</div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {

  },
  data() {
    const memorialsItemsStr = localStorage.getItem("memorialsItems");
    const meetingInfoStr = localStorage.getItem("meetingInfo");
    const agenciesStr = localStorage.getItem("agencies");
    let memorialsItemsData = [];
    let meetingInfoData = {};
    let agenciesData = [];
    try {
      if (memorialsItemsStr) {
        memorialsItemsData = JSON.parse(memorialsItemsStr);
      }
      if (meetingInfoStr) {
        meetingInfoData = JSON.parse(meetingInfoStr);
      }
      if (agenciesStr && agenciesStr != [] && agenciesStr != "[]") {
        agenciesData = JSON.parse(agenciesStr);
      }
    } catch (error) {
      console.error("解析本地存储数据出现错误:", error);
    }
    // 这里存放数据
    return {
      memorialsItems: memorialsItemsData,
      selectedItems:[],
      meetingInfo:{},
      showPriceDetail: false,
      checked: false,
      agenciesList: [{
        name: '',
        price: "",
        photo:""
      }],
      meetingMoney:Number(JSON.parse(localStorage.getItem("meetingInfo")).price),
      totalMoney: ''
    }
  },
  // 监听属性 类似于data概念
  computed: {
    
  },
  // 监控data中的数据变化
  watch: {
  },
  // 方法集合
  methods: {
    handleChange(index) {
      this.updateSelectedTotal();
    },
    handleSelectedChange(index) {
      console.log(index)
      const currentObj = this.agenciesList[index];
      if (currentObj.checked) {
        const insertIndex = this.agenciesList.map(o => o.name).indexOf(currentObj.name);
        if (this.selectedItems.findIndex(obj => obj.name === currentObj.name) === -1) {
          this.selectedItems.splice(insertIndex, 0, currentObj);
        }
      } else {
        const indexToRemove = this.selectedItems.findIndex(obj => obj.name === currentObj.name);
        if (indexToRemove!== -1) {
          this.selectedItems.splice(indexToRemove, 1);
        }
      }
      this.updateSelectedTotal();
    },
    updateSelectedTotal() {
      this.totalMoney = Number(this.meetingInfo.sumPrice) + Number(this.selectedItems.reduce((acc, cur) => acc + (cur.price * cur.count), 0));
    },
    onNextStep() {
      let meetingInfo =  JSON.parse(localStorage.getItem("meetingInfo"));
      localStorage.setItem("agencies", JSON.stringify(this.selectedItems))
      // meetingInfo.sumPrice = this.totalMoney
      localStorage.setItem("meetingInfo", JSON.stringify(meetingInfo))
      this.$router.push("/querenxinxi")
      
    },
    goHome() {
      this.$router.push("/")
    },
  },
  // 生命周期-创建完成（可以访问当前this实例）
  created() {
    const storedInfo = localStorage.getItem("meetingInfo");
    var checkedAgencies =  localStorage.getItem("agencies");
    if (storedInfo) {
        try {
            const meetingInfo = JSON.parse(storedInfo);
            this.meetingInfo = meetingInfo;
            this.agenciesList = meetingInfo.agencies;
            this.totalMoney = meetingInfo.sumPrice;
            if(checkedAgencies){
               let checked = JSON.parse(checkedAgencies)
               checked.forEach(aObj => {
                  let indexInB =  this.agenciesList.findIndex(bObj => JSON.stringify(bObj.name) === JSON.stringify(aObj.name));
                  if (indexInB!== -1 && aObj.checked) {
                    this.agenciesList[indexInB].checked = true;
                    this.agenciesList[indexInB].count = aObj.count;
                    this.handleSelectedChange(indexInB)
                  }
               });
              //  this.updateSelectedTotal()
            }
        } catch (error) {
            console.error("解析存储的meetingInfo出现错误:", error);
        }
    } else {
        console.log("本地存储中不存在meetingInfo数据");
        // 这里可以根据实际需求进行一些初始化操作，比如给agenciesList和totalMoney赋默认值等
        this.agenciesList = [];
        this.totalMoney = 0;
    }
  },
  // 生命周期-挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期-创建之前
  beforeMount() { }, // 生命周期-挂载之前
  beforeUpdate() { }, // 生命周期-更新之前
  updated() { }, // 生命周期-更新之后
  beforeDestroy() { }, // 生命周期-销毁之前
  destroyed() { }, // 生命周期-销毁完成
  activated() { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.top-image {
  height: 163px;
  width: 100%;
  position: absolute;
  margin-top: -16px;
  z-index: -6;
}

/* 奉物卡片 */
.goods-container {
  margin: 16px 12px 106px;
  background: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.container-name {
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #000;
  letter-spacing: 0;
  font-weight: 600;
  padding: 16px 0 7px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.item-list-container {
  overflow: auto;
  padding-top: 2px;
  padding-bottom: 8px;
}

.perItem-last {
  margin: 12px 12px 0;
}

.item-left {
  width: 28px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 20px;
}

.item-middle {
  width: 100px;
  height: 100%;
  margin-right: 9px;
}

.ticket-picture {
  border-radius: 10px;
  width: 100px;
  height: 100px;
  background-size: cover;
}

.item-right {
  width: 58%;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.perItem-name {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #000;
  letter-spacing: 0;
  font-weight: 600;
  margin-bottom: 5px;
}

.perItem-description {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.8);
  letter-spacing: 0;
  font-weight: 400;
  margin-bottom: 15px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  min-height: 34px;
}

.item-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.perItem-price {
  font-family: HelveticaNeue-Bold;
  font-size: 18px;
  color: #e65c2e;
  letter-spacing: 0;
  font-weight: 700;
}

.perItem-count {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  height: 24px;
}

/* 底部控制栏 */
/* 底部容器样式 */
.bottom-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 72px;
  background-color: #fff;
  -webkit-box-shadow: inset 0 1px 0 0 #eee;
  box-shadow: inset 0 1px 0 0 #eee;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 32px;
  z-index: 2999;
}

.scroll-wrapper {
  min-height: 200px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.price-type {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  line-height: 22px;
  color: #000;
}

.price-type-name {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}

.price-type-money {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.communion-price[data-v-17536f08],
.order-price-container .cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 43px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.order-price-container .cell .title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  font-family: PingFangSC-Regular, PingFang SC;
  margin-bottom: 4px;
}

.order-price-container .cell .money {
  font-size: 14px;
  color: #000;
  margin-left: auto;
  font-family: PingFangSC-Regular, PingFang SC;
}

.checkList-container {
  padding-bottom: 20px;
}

.bottom-container .money-wrap .symbol {
  font-size: 14px;
  color: #e65c2e;
  font-weight: 700;
  font-family: HelveticaNeue-Bold, HelveticaNeue;
}

.bottom-container .money-wrap .money {
  font-size: 20px;
  color: #e65c2e;
  font-weight: 700;
  font-family: HelveticaNeue-Bold, HelveticaNeue;
}

.bottom-container .detail-wrap {
  margin: 2px 0 2px 8px;
}

.detail-wrap img {
  margin-left: 5px;
}

.bottom-container .detail-wrap .detail-text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  font-family: PingFangSC-Regular, PingFang SC;
}

.bottom-container .detail-wrap>img {
  width: 14px;
  height: 14px;
  vertical-align: bottom;
  -webkit-transition: -webkit-transform 0.5s;
  transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
  transition: transform 0.5s, -webkit-transform 0.5s;
}

.submit-order {
  width: 160px;
  height: 40px;
  line-height: 40px;
  background: linear-gradient(133deg, #007aaa, #004e93);
  border-radius: 22px;
  font-size: 16px;
  color: #fff;
  margin-left: 43px;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  text-align: center;
  -webkit-box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  font-family: PingFangSC-Regular, PingFang SC;
}

/* 首页按钮 **********/
.btn-home {
  width: 44px;
  height: 44px;
  background: #fff;
  border: 1px solid #007aaa;
  border-radius: 22px;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: fixed;
  bottom: 106px;
  right: 15px;
  z-index: 999;
}

.img-home {
  width: 20px;
  height: 20px;
}

.text-home {
  font-size: 10px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #007aaa;
}

.van-popup--bottom {
  background-color: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  -webkit-transition: -webkit-transform 0.5s;
  transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
  transition: transform 0.5s, -webkit-transform 0.5s;
  z-index: 201;
  min-height: 148px;
  padding: 16px 16px 72px;
  overflow: hidden;
  width: auto;
}

.van-popup--bottom img {
  position: absolute;
  right: 16px;
  top: 16px;
  width: 10px;
}

.van-popup--bottom .detail-title {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  font-family: PingFangSC-Medium, PingFang SC;
  text-align: center;
}

.van-popup--bottom {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.van-popup--bottom .cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 8px;
}

.van-popup--bottom .cell .title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  font-family: PingFangSC-Regular, PingFang SC;
}

.van-popup--bottom .cell .money {
  font-size: 14px;
  color: #000;
  margin-left: auto;
  font-family: PingFangSC-Regular, PingFang SC;
}
</style>